// masterGameReducer.js

import { UPDATE_GAME } from '../types';

const initialState = {
  game: null,
};

const masterGameReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_GAME:
      return {
        ...state,
        game: action.payload,
      };
    default:
      return state;
  }
};

export default masterGameReducer;
